<template>
    <div v-show="getShowDeclineModal" class="decline">
        <div class="decline__modal">
            <div class="decline__img">
                <!-- <img src="@/assets/images/icons/error.svg" alt="icon" /> -->
            </div>
            <div class="decline__text-container">
                <div class="decline__title">Оплата скасована</div>
                <div class="decline__text">
                    Ви скасували оплату.<br /><br />
                    Якщо це сталося випадково, ви можете повторити спробу оплатити пізніше або зв’язатися з нами для
                    уточнення деталей.
                </div>
            </div>
            <div class="decline__button">
                <black-button @black-button-event="confirm">Повернутися до сервісу</black-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import BlackButton from "../base/BlackButton.vue";

export default {
    components: {
        BlackButton,
    },
    computed: mapGetters("UI", ["getShowDeclineModal"]),
    methods: {
        ...mapMutations("UI", ["SET_DECLINE"]),
        ...mapMutations("dropdown", ["RESET_DROPDOWN_DATA"]),
        ...mapMutations("registration", ["RESET_REGISTRATION_DATA"]),
        confirm() {
            this.SET_DECLINE(false);
            this.RESET_DROPDOWN_DATA();
            this.RESET_REGISTRATION_DATA();

            const newUrl = window.location.href.split("#")[0];
            history.replaceState(null, "", newUrl);
        },
    },
};
</script>

<style lang="scss">
.decline {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.2);

    &__modal {
        display: flex;
        flex-direction: column;
        align-items: center;
        row-gap: 20px;
        max-width: 350px;
        padding: 30px 20px;
        border-radius: 24px;
        background: #fff;
        box-shadow: 0px 18px 88px -4px rgba(24, 39, 75, 0.14), 0px 8px 28px -6px rgba(24, 39, 75, 0.12);
    }
    &__text {
        text-align: center;
    }

    &__title {
        margin-bottom: 10px;
        text-align: center;
        color: #000;
        font-size: 24px;
        font-weight: 500;
        line-height: normal;
    }
}
</style>
